module.exports = __webpack_public_path__ + "static/media/whyus_compromiso.3e63c18a.jpg";